<template>
  <v-dialog v-model="dialog" fullscreen>
    <v-btn slot="activator" color="primary" dark>
      Bulk Import Export
    </v-btn>
    <v-toolbar color="primary">
      <v-spacer></v-spacer>
      <v-btn icon flat @click="dialog = false">
        <v-icon color="white">close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card>
      <v-container>
        <v-card-title>
          <span class="headline">Bulk Import Export</span>
          <v-btn
            color="primary"
            href="https://firebasestorage.googleapis.com/v0/b/engineer-ae17e.appspot.com/o/docs%2FBulk%20export%20template.xlsx?alt=media&token=69eb48b7-6a9c-46ee-911e-2926b3fff5f7"
          >
            Download Excel Template
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-autocomplete v-model="Customer" :items="customerList" :loading="gettingCustomers" label="Select a Customer" item-text="name"
            item-value="key" required :rules="[v => !!v || 'Customer is required']" :disabled="customerFixed"></v-autocomplete>
          <v-autocomplete label="Project" v-model="Project" :items="Projects" item-text="name" item-value="name"></v-autocomplete>
          <template v-if="jobs !== null">
          <v-autocomplete :disabled="exported" chips clearable deletable-chips multiple v-model="selectedExportHeaders" :items="templates" item-text="name" return-object label="Select Devices being worked on"></v-autocomplete>
          <v-btn :disabled="selectedExportHeaders < 1 || Project === null" @click="exportData">Export Project Data</v-btn>
            <v-btn
              v-if="exported"
              color="primary"
              dark
              @click="exported = false; excelInput = ''; dataProcessed = false"
            >
              Reset
            </v-btn>
              <div>
                <v-alert
                  v-model="exported"
                  dismissible
                  type="success"
                >
                  Data Exported To Clipboard Successfully. Please make any alterations and paste data into below textbox to process.
                </v-alert>
              </div>
            <v-textarea :readonly="!exported" id="excelInput" v-model="excelInput" label="Excel Data Input"></v-textarea>
            <v-layout row v-if="exported">
              <v-checkbox v-model="includeHeaders" label="Input includes header row"></v-checkbox>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="processRawData" :disabled="!Customer || !excelInput || saving" :loading="processing">Process Data</v-btn>
            </v-layout>
          </template>
          <div v-if="dataProcessed" class="mt-5">
            <span class="title">Output Data</span>
            {{changes.length}} jobs have been altered
            <v-data-table :pagination.sync="pagination" hide-actions :items="processedData" :headers="headers">
              <template slot="items" slot-scope="props">
                <tr>
                  <td>{{props.item.id}}</td>
                  <td :class="{'green' : props.item.vehReg !== jobs[props.item.id].vehReg}">{{props.item.vehReg}}</td>
                  <td :class="{'green' : jobs[props.item.id].templates.indexOf(props.item.type) === -1}">{{props.item.type}}</td>
                  <td>{{props.item.deviceType}}</td>
                  <td>{{props.item.product}}</td>
                  <td>{{props.item.stockLocation}}</td>
                  <td v-for="header in exportHeaders" :key="header.name" :class="props.item.invalidSim && header === 'SIM' ? 'red' : props.item[header] !== 'N/A' && props.item[header] !== '' && (devices.find(d => d.type === props.item.template && d.id === props.item.uid) === undefined || devices.find(d => d.type === props.item.template && d.id === props.item.uid)[header] !== props.item[header]) ? 'green' : ''">{{props.item[header]}}</td>
                </tr>
              </template>
            </v-data-table>
            <v-layout align-center>
              <v-spacer></v-spacer>
              <v-checkbox class="shrink" label="I confirm the above output is correct" v-model="dataLooksGood"></v-checkbox>
              <v-btn color="primary" @click="saveData" :disabled="!dataLooksGood || invalidData" :loading="saving">Save Vehicles</v-btn>
            </v-layout>
          </div>
        </v-card-text>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import { fireStore } from '../../firebase'
export default {
  props: ['parentCustomer', 'customerFixed'],
  data () {
    return {
      dialog: false,
      excelInput: '',
      includeHeaders: false,
      dataProcessed: false,
      processing: false,
      saving: false,
      processedData: [],
      exported: false,
      invalidData: false,
      headers: [
        {
          text: 'UID',
          value: 'id',
          align: 'left'
        },
        {
          text: 'Vehicle Reg.',
          value: 'vehReg',
          align: 'left'
        }
      ],
      pagination: {rowsPerPage: -1},
      dataLooksGood: false,
      gettingCustomers: false,
      customerList: [],
      Projects: [],
      exportHeaders: [],
      selectedExportHeaders: [],
      Customer: null,
      Project: null,
      jobs: null,
      importedJobs: [],
      changes: [],
      vehicles: [],
      regChanges: []
    }
  },
  created () {
    this.getCustomers()
    this.getVehicles()
  },
  mounted () {
    this.$store.dispatch('fetchDeviceTypes')
    this.$store.dispatch('fetchProductTypes')
    this.$store.dispatch('fetchDevices')
    this.$store.dispatch('fetchSIMS')
    this.Customer = this.parentCustomer
  },
  watch: {
    // selectedExportHeaders: function (val) {
    //   this.exportHeaders = []
    //   for (let product in this.selectedExportHeaders) {
    //     for (let header in this.selectedExportHeaders[product]) {
    //       this.exportHeaders.push(this.selectedExportHeaders[product][header])
    //     }
    //   }
    //   this.headers = [
    //     {
    //       text: 'UID',
    //       value: 'id',
    //       align: 'left'
    //     },
    //     {
    //       text: 'Vehicle Reg.',
    //       value: 'vehReg',
    //       align: 'left'
    //     }
    //   ]
    //   for (let header in this.exportHeaders) {
    //     this.headers.push(
    //       {
    //         text: this.exportHeaders[header],
    //         value: this.exportHeaders[header],
    //         align: 'left'
    //       }
    //     )
    //   }
    // },
    dataLooksGood: function (val) {
      if (val && this.invalidData) {
        alert('Some data is not valid, look for red cells.')
        setTimeout(() => {
          this.dataLooksGood = false
        }, 20)
      }
    },
    parentCustomer: function (val) {
      this.Customer = val
    },
    Customer: function (val) {
      if (val) {
        this.getProjects()
      }
    },
    Project: function (val) {
      if (val) {
        this.getJobs()
      }
    }
  },
  computed: {
    userData () {
      return this.$store.getters.userData
    },
    templates () {
      return this.$store.getters.deviceTypes.filter(device => { return device.extras && device.extras.findIndex(extra => { return extra.type === 'uid' }) !== -1 })
    },
    products () {
      return this.$store.getters.productTypes
    },
    devices () {
      return this.$store.getters.devices
    },
    sims () {
      return this.$store.getters.SIMS
    }
  },
  methods: {
    getCustomers () {
      this.gettingCustomers = true
      fireStore.collection('Customers').get()
      .then(snap => {
        snap.forEach(doc => {
          this.customerList.push({key: doc.id, name: doc.data().customerName, shortName: doc.data().shortName})
        })
        this.customerList.sort(function (a, b) {
          const aName = a.name.toLowerCase()
          const bName = b.name.toLowerCase()
          return aName < bName ? -1 : aName > bName ? 1 : 0
        })
        this.gettingCustomers = false
      })
    },
    exportData () {
      let finalString = ''
      finalString += 'UID' + '\t' + 'Vehicle' + '\t' + 'Template' + '\t' + 'Device Name' + '\t' + 'Product Name' + '\t' + 'Stock Location' + '\t'
      this.headers = [
        {
          text: 'UID',
          value: 'id',
          align: 'left'
        },
        {
          text: 'Vehicle Reg.',
          value: 'vehReg',
          align: 'left'
        },
        {
          text: 'Template ID',
          value: 'type',
          align: 'left'
        },
        {
          text: 'Device Name',
          value: 'deviceType',
          align: 'left'
        },
        {
          text: 'Product Name',
          value: 'product',
          align: 'left'
        },
        {
          text: 'Stock Location',
          value: 'stockLocation',
          align: 'left'
        }
      ]
      let dataHeaderArray = []
      for (let job of this.selectedExportHeaders) {
        for (let header of job.extras) {
          if (dataHeaderArray.indexOf(header.name) === -1) {
            dataHeaderArray.push(header.name)
          }
        }
      }

      this.exportHeaders = dataHeaderArray

      for (let dataHeader of dataHeaderArray) {
        finalString += dataHeader
        finalString += '\t'
        this.headers.push(
          {
            text: dataHeader,
            value: dataHeader,
            align: 'left'
          }
        )
      }
      finalString += '\n'
      let exportArray = []
      for (let job in this.jobs) {
        for (let template of this.jobs[job].templates) {
          if (this.selectedExportHeaders.findIndex(h => h.id === template) !== -1) {
            let productString = ''
            let thisJob = this.jobs[job]
            thisJob.products = thisJob.products === undefined ? [] : thisJob.products
            productString += thisJob.id + '\t' + (thisJob.Vehicle ? this.vehicleRegFromID(thisJob.Vehicle) : thisJob.vehReg ? thisJob.vehReg : '') + '\t' + template + '\t' + this.templates.find(t => t.id === template).name + '\t'
            // Go and get the details of the active device and if there isn't one return an object containing all the keys that device would need.
            let activeDevice = this.devices.find((device) => { return device.vehicle === thisJob.Vehicle && device.type === template }) || Object.assign({}, ...(this.templates.find(t => t.id === template).extras.map(item => ({[item.name]: ''}))))
            if (!activeDevice.product) {
              productString += this.products.find(p => { return (thisJob.products.indexOf(p.id) !== -1 && p.devices.indexOf(template) !== -1) || p.id === template }).id + '\t'
            } else {
              productString += activeDevice.product + '\t'
            }
            if (!activeDevice.stockLocation) {
              productString += 'New Stock' + '\t'
            } else {
              productString += activeDevice.stockLocation + '\t'
            }
            console.log(thisJob)
            for (let header in dataHeaderArray) {
              let dataHeader = dataHeaderArray[header]
              if (!activeDevice[dataHeader] && thisJob.extras && thisJob.extras[template] && thisJob.extras[template][dataHeader]) {
                productString += thisJob.extras[template][dataHeader]
              } else if (activeDevice[dataHeader] !== undefined) {
                productString += activeDevice[dataHeader]
              } else {
                productString += 'N/A'
              }
              productString += '\t'
            }
            productString += '\n'
            exportArray.push({product: template, productString: productString})
          }
        }
      }

      exportArray.sort(function (a, b) {
        const aName = a.product
        const bName = b.product
        return aName < bName ? -1 : aName > bName ? 1 : 0
      })

      for (let product of exportArray) {
        finalString += product.productString
      }
      // console.log(finalString)
      // const el = document.createElement('textarea')
      // el.setAttribute('readonly', '')
      // el.style.position = 'absolute'
      // el.style.left = '-9999px'
      // document.body.appendChild(el)
      this.excelInput = finalString
      // el.value = finalString
      setTimeout(() => {
        document.getElementById('excelInput').select()
        document.execCommand('copy')
        this.exported = true
        this.excelInput = ''
      }, 20)
    },
    getProjects () {
      this.Projects = []
      this.Project = null
      fireStore.collection('Projects').where('Customer', '==', this.Customer)
      .get()
      .then(snap => {
        snap.forEach(doc => {
          this.Projects.push({key: doc.id, name: doc.data().projectId})
        })
      })
    },
    getJobs () {
      this.jobs = {}
      fireStore.collection('Jobs').where('Customer', '==', this.Customer).where('Project', '==', this.Project)
      .get()
      .then(snap => {
        snap.forEach(doc => {
          let jobData = doc.data()
          jobData.id = doc.id
          this.jobs[doc.id] = jobData
        })
      })
    },
    getVehicles () {
      this.vehicles = []
      fireStore.collection('Vehicles')
      .get()
      .then(snap => {
        snap.forEach(doc => {
          let data = doc.data()
          data.key = doc.id
          this.vehicles.push(data)
        })
      })
    },
    processRawData () {
      this.invalidData = false
      console.log('processing')
      this.processing = true
      this.processedData = []
      let rows = []
      this.changes = []
      this.regChanges = []
      rows = this.excelInput.split('\n')
      if (this.includeHeaders) {
        rows.splice(0, 1)
      }
      rows.forEach((row, rowID) => {
        if (row === '') {
          return
        }
        const cols = row.split('\t')
        if (this.jobs[cols[0]] === undefined) {
          alert('You are trying to import data for ID ' + cols[0] + '. This ID is not in the system. Please ensure you have not added rows to the export.')
        } else {
          const thisJob = this.jobs[cols[0]]
          const obj = {
            vehicle: thisJob.Vehicle,
            id: cols[0] ? cols[0] : '',
            vehReg: cols[1] ? cols[1] : '',
            type: cols[2] ? cols[2] : '',
            deviceType: cols[3] ? cols[3] : '',
            product: cols[4] ? cols[4] : '',
            stockLocation: cols[5] ? cols[5] : ''
          }
          let cOffset = 6
          const reg = (thisJob.Vehicle ? this.vehicleRegFromID(thisJob.Vehicle) : thisJob.vehReg ? thisJob.vehReg : '')
          if (reg !== cols[1]) {
            const newRegObj = {
              id: thisJob.Vehicle,
              oldReg: reg,
              newReg: cols[1]
            }
            this.regChanges.push(newRegObj)
          }

          let idField = this.templates.find((device) => device.id === cols[2]).extras.find(e => e.type === 'uid').name
          let activeDevice = this.devices.find((device) => { return device.vehicle === thisJob.Vehicle && device.type === cols[2] }) || Object.assign({}, ...(this.templates.find(t => t.id === cols[2]).extras.map(item => ({[item.name]: ''}))))
          for (let index = cOffset; index < this.exportHeaders.length + cOffset; index++) {
            obj[this.exportHeaders[index - cOffset]] = cols[index] ? cols[index] : ''
            if (this.exportHeaders[index - cOffset] === idField) {
              obj.uid = cols[index]
            }
            if (activeDevice[this.exportHeaders[index - cOffset]] != cols[index] && cols[index] !== 'N/A') {
              if (this.changes.indexOf(rowID) === -1) {
                this.changes.push(rowID)
              }
            }
          }
          if (obj.SIM && obj.SIM.length > 0 && this.sims.findIndex(s => s.ICCID === obj.SIM) === -1 && obj.SIM !== 'N/A') {
            obj.invalidSim = true
            this.invalidData = true
          }
          this.processedData.push(obj)
        }
      })
      this.dataProcessed = true
      this.processing = false
    },
    saveData () {
      this.saving = true
      let Promises = []
      let jobs = []
      for (let i in this.processedData) {
        let device = this.processedData[i]
        if (this.changes.indexOf(i * 1) !== -1) {
          if (!device.uid) {
            this.saving = false
            alert('Unable to import devices as unique ID (usually serial number or ESN) is missing from some devices.')
            return
          }
          device.id = device.uid
          device.customer = this.Customer
          jobs.push(device.uid)
          Promises.push(new Promise((resolve, reject) => {
            fireStore.collection('Devices').doc(device.uid).set(device, { merge: true })
              .then(result => {
                resolve(result)
              })
              .catch(error => {
                console.log(device)
                reject(error)
              })
          }))
        }
      }
      this.regChanges.forEach(regObj => {
        Promises.push(new Promise((resolve, reject) => {
          fireStore.collection('Vehicles').doc(regObj.id).update({VehicleReg: regObj.newReg})
            .then(result => {
              this.$emit('updatingVehicleReg', regObj)
              resolve(result)
            })
            .catch(error => {
              reject(error)
            })
        }))
      })
      Promise.all(Promises).then(values => {
        const changeAmount = this.changes.length
        const logObj = {
          uid: this.userData.UID,
          name: this.userData.Name,
          action: 'Bulk edited ' + changeAmount + ' jobs. Updated ' + this.regChanges.length + ' vehicle regs.',
          customer: this.Customer,
          jobs: jobs
        }
        fireStore.collection('Log').add(logObj)
        .then(ref => {
          console.log(ref)
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => {
          this.saving = false
          this.close()
        })
      })
      .catch(error => {
        console.log(error)
      })
    },
    close () {
    //   this.$emit('update:dialog', false)
      this.dialog = false
      setTimeout(() => {
        this.excelInput = ''
        this.processedData = []
        this.Site = null
        this.dataLooksGood = false
        this.sites = []
        this.dataProcessed = false
      }, 300)
    },
    vehicleRegFromID (id) {
      const index = this.vehicles.findIndex(vehicle => {
        return vehicle.key === id
      })
      if (index > -1) {
        if (this.vehicles[index]['VehicleReg']) {
          return this.vehicles[index]['VehicleReg']
        } else if (this.vehicles[index]['friendlyId']) {
          return this.vehicles[index]['friendlyId']
        }
      } else {
        return ''
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// BulkImportExportDialog.vue?61718b31